import { render, staticRenderFns } from "./ChannelPartnersList.vue?vue&type=template&id=bed80f20"
import script from "./ChannelPartnersList.vue?vue&type=script&lang=js"
export * from "./ChannelPartnersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports